import CampaignRemoteSource from './schema/CampaignRemoteSource';
import { beginLightning, endLightning } from 'owa-lightning-core-v2';
import { initializeLightningIfNecessary } from 'owa-lightning-core-v2/lib/utils/initializeLightningIfNecessary';
import { setLastShownLightning } from '../mutators/setLastShownLightning';
import { resolveLightningPromises } from 'mini-campaign-bootstrap/lib/utils/isLightningIdPresent';
import { CampaignEndSignal } from './schema/CampaignEndSignal';
import { ActionTypes } from './schema/ActionTypes';

/**
 * Class to instantiate a lightning remote source object
 */
class CampaignLightningRemoteSource implements CampaignRemoteSource {
    private static singularInstance: CampaignLightningRemoteSource;
    private static campaignActionTypes: Map<string, ActionTypes>;

    private constructor() {
        initializeLightningIfNecessary().then(() => {
            resolveLightningPromises();
        });
    }

    /**
     * This method creates an instance of CampaignLightningRemoteSource if not already present and always returns the same instance.
     */

    public static getInstance(campaignId: string, actionTypes: ActionTypes) {
        if (!CampaignLightningRemoteSource.singularInstance) {
            CampaignLightningRemoteSource.singularInstance = new CampaignLightningRemoteSource();
        }
        if (!CampaignLightningRemoteSource.campaignActionTypes) {
            CampaignLightningRemoteSource.campaignActionTypes = new Map();
        }
        CampaignLightningRemoteSource.campaignActionTypes.set(campaignId, actionTypes);
        return CampaignLightningRemoteSource.singularInstance;
    }

    public start(campaignId: string) {
        const onLightUp = lightup => {
            lightup();
        };
        beginLightning(campaignId, onLightUp);
    }

    // This is required to be called to set last shown lightning id otherwise endlightning may not happen if the id does not match.

    public end(campaignId: string, endSignal: CampaignEndSignal) {
        campaignId && setLastShownLightning(campaignId);
        const actionTypes = CampaignLightningRemoteSource.campaignActionTypes?.get(campaignId);
        if (actionTypes && endSignal in actionTypes) {
            endLightning.importAndExecute(campaignId, actionTypes[endSignal]);
            CampaignLightningRemoteSource.campaignActionTypes?.delete(campaignId);
        }
    }
}

export default CampaignLightningRemoteSource;
